import { observable, action, runInAction } from 'mobx'
import Api from '@api/xi_feng/newCustomer'

class Store {
  @observable question_visibility = false
  @observable current_budget = {}
  @observable survey = []

  checkbox_extra = {}
  radio_extra = {}

  constructor(addCustomerStore) {
    this.addCustomerStore = addCustomerStore
  }

  /** 调查问卷相关 */
  @action
  toggleQuestionnaire = async (current, is_switch) => {
    if (!this.question_visibility || is_switch) {
      const { success, data } = await Api.surveyInfo({ property_id: current })
      if (success) {
        runInAction(() => {
          this.current_budget = data
        })
      }
    }
    if (!is_switch) {
      runInAction(() => {
        this.question_visibility = !this.question_visibility
      })
    }
  }

  @action
  getFunc = (name, value) => {
    runInAction(() => {
      this[name] = value
    })
  }

  //获取已提交答案的问卷
  @action
  hasAnswersProperty = answers => {
    return answers.map(item => item.id)
  }

  //获取调查问卷的答案
  @action
  getSurvey = (answers, id, property_id) => {
    let _survey = [...this.survey]
    let has_survey_id = false
    _survey.forEach(item => {
      if (item.property_id == property_id) {
        item.answers = answers
        item.survey_id = id
        has_survey_id = true
      }
    })
    if (!has_survey_id) {
      _survey.push({
        survey_id: id,
        answers,
        property_id
      })
    }
    //console.log(_survey)
    runInAction(() => {
      this.survey = _survey
    })
  }

  @action
  getInfo = () => {
    const { updateSurveyInfo } = this.addCustomerStore

    this.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let answers = []
        let text_answers = []
        let text_content = []
        Object.keys(values).forEach(item => {
          const name_list = item.split('_')
          if (name_list[0] === 'checkbox') {
            let content = values[item].map(val => {
              let text = ''
              let vals = val.split('_')
              Object.keys(this.checkbox_extra).forEach(name => {
                if (name.split('_')[2] == vals[0]) {
                  text = this.checkbox_extra[name]
                }
              })
              return {
                option_id: vals[0],
                text,
                name: vals[1]
              }
            })
            content.length &&
              answers.push({
                question_id: name_list[1],
                content
              })
          }

          if (name_list[0] === 'radio') {
            let text = ''
            let vals = values[item].split('_')
            Object.keys(this.radio_extra).forEach(name => {
              if (name.split('_')[2] == vals[0]) {
                text = this.radio_extra[name]
              }
            })
            let content = [
              {
                option_id: vals[0],
                text,
                name: vals[1]
              }
            ]

            values[item] &&
              answers.push({
                question_id: name_list[1],
                content
              })
          }

          if (name_list[0] === 'text' && name_list.length === 5) {
            if (text_answers.includes(name_list[1])) {
              if (values[item]) {
                text_content.push({
                  option_id: name_list[2],
                  text: values[item],
                  name: name_list[4]
                })
              }
              answers.find(
                item => item.question_id == name_list[1]
              ).content = text_content
            } else {
              text_content = []
              if (values[item]) {
                text_content.push({
                  option_id: name_list[2],
                  text: values[item],
                  name: name_list[4]
                })
              }
              answers.push({
                question_id: name_list[1],
                content: text_content
              })
              text_answers.push(name_list[1])
            }
          }

          if (name_list[0] === 'text' && name_list.length === 2) {
            values[item] &&
              answers.push({
                question_id: name_list[1],
                content: [
                  {
                    text: values[item]
                  }
                ]
              })
          }
        })
        text_content = []
        text_answers = []
        const _answers = answers.filter(
          item => item.content && item.content.length
        )
        //console.log(answers)
        const { id, questions, property_id } = this.current_budget
        this.getSurvey(_answers, id, property_id)
        updateSurveyInfo(_answers, questions, property_id)
      }
    })
  }

  setInputVal = (name, list, value) => e => {
    let _name = name.split('_')
    if (_name[3] === 'checkbox') {
      list[name] = value ? value : e.target.value
      this.checkbox_extra[name] = value ? value : e.target.value
    } else if (_name[3] === 'radio') {
      list[name] = value ? value : e.target.value
      this.radio_extra[name] = value ? value : e.target.value
    }
  }
}

export default Store
